import React from 'react';
import { DatePicker } from '@material-ui/pickers';

export const CustomDatePicker = ({
  label,
  name,
  date,
  handleDateSelect,
  minDate,
  disabled,
  format = 'MM/DD/YYYY',
}) => (
  <DatePicker
    disableToolbar
    variant="inline"
    required
    label={label}
    format={format}
    name={name}
    value={date}
    minDate={minDate}
    onChange={date => handleDateSelect(date, name)}
    animateYearScrolling
    inputVariant="outlined"
    disabled={disabled}
  />
);
